import React from 'react';
import { FadeIn } from './FadeIn';
const pillars = [{
  numeral: 'I',
  title: 'Executive Principle',
  description: 'The Executive Branch is selected through public vote, while leadership eligibility requires demonstrated competence and constitutional fitness. Performance is secondary to verified cognitive stability.'
}, {
  numeral: 'II',
  title: 'Deliberative Principle',
  description: 'Legislation is evaluated for long-term consequence, institutional coherence, and public stability. The active franchise requires foundational reality-testing to prevent systemic capture.'
}, {
  numeral: 'III',
  title: 'Judicial Principle',
  description: 'Constitutional safeguards prevent the abuse of competence standards as a cover for arbitrary domination. The Deep Index decentralizes power among those with the highest verified judgment.'
}];
export function ConstitutionalOrder() {
  return <section className="py-24 md:py-32 bg-cognarch-white relative border-t border-cognarch-border" data-id="element-27">
      <div className="max-w-7xl mx-auto px-6" data-id="element-28">
        <FadeIn data-id="element-29">
          <div className="text-center mb-24" data-id="element-30">
            <h2 className="text-3xl md:text-5xl font-serif mb-6 text-cognarch-charcoal" data-id="element-31">
              Constitutional Order
            </h2>
            <div className="w-24 h-px bg-cognarch-charcoal/20 mx-auto" data-id="element-32" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-16" data-id="element-33">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={0.2 * index} className="relative" data-id="element-34">
              {/* Vertical connecting lines for desktop */}
              {index !== pillars.length - 1 && <div className="hidden md:block absolute top-1/2 -right-4 lg:-right-8 w-px h-32 -translate-y-1/2 bg-gradient-to-b from-transparent via-cognarch-border to-transparent" data-id="element-35" />}

              <div className="flex flex-col items-center text-center" data-id="element-36">
                <div className="w-16 h-16 flex items-center justify-center border border-cognarch-charcoal/20 rounded-full mb-8 relative group" data-id="element-37">
                  <div className="absolute inset-0 bg-cognarch-charcoal/5 rounded-full scale-0 group-hover:scale-100 transition-transform duration-500" data-id="element-38" />
                  <span className="font-serif text-2xl text-cognarch-charcoal relative z-10" data-id="element-39">
                    {pillar.numeral}
                  </span>
                </div>

                <h3 className="text-2xl font-serif mb-6 text-cognarch-charcoal" data-id="element-40">
                  {pillar.title}
                </h3>

                <p className="text-cognarch-gray leading-relaxed" data-id="element-41">
                  {pillar.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}